import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import axios from "axios";
import Cookies from "js-cookie";
import settings from "../helpers/Settings";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";

let { KayanURL } = settings;

const LoginAsEmployee = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState("admin");
  const [Company, setCompany] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setErrMsg] = useState("")
  const [loginRequest, setRequest] = useState(null)
  const [loginResponse, setResponse] = useState(null)
  useEffect(() => {
    if (Company === "Admin")
      setRole("admin");
    else
      setRole('employee')
  }, [Company]);

  const handelAdminLogIn = async (e) => {
    e.preventDefault();
    setRequest(true)
    setResponse(false)
    if (Company === "Admin") {
      try {
        const result = await axios.post(
          KayanURL + "api/KSA/RCM/admin/login",
          {
            username: username.trim(),
            password: password.trim(),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (result) {
          setRequest(false)
          setResponse(true)
          const { data } = result;
          if (data) {
            if (data.success) {
              Cookies.set("RCM_KSA_Admin_Token", data.apiToken);
              navigate('/admin');

            } else {
              const { error } = data;
              if (error) {
                setErrMsg(error);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error during admin login:", error);
      }
    }
  };

  const handelDoctorLogIn = async (e) => {
    setRequest(true)
    setResponse(false)
    e.preventDefault();
    try {
      const result = await axios.put(KayanURL + "api/KSA/RCM/employee/doctorLogin", {
        companyname: Company,
        username: username,
        password: password,
      });

      if (result) {
        setRequest(false)
        setResponse(true)
        const { data } = result;
        if (data) {
          if (data.success) {
            Cookies.set("RCM_KSA_Employee_Token", data.apiToken,{path:'/'});
            localStorage.setItem("doctor-name", data.doctorName);
            localStorage.setItem("doctor-id", data.doctorID);
            localStorage.setItem("nphies-id", data.nphiesID);
            localStorage.setItem("nphies-provider-name", data.nphiesName)
            navigate("/KSA-RCM", { state: { role: data.role } });

          } else {
            const { error } = data;
            if (error) {
              setErrMsg(error);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during doctor login:", error);
    }
  }
  return (
    <Box>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "700px"
      }}>
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "30px",
            width: "50%",
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
            height: "400px"
          }}>
          <div>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: "center", fontSize: "16px" }}>
              Welcome to SAMA
            </Typography>
          </div>

          <div style={{ width: "50%", margin: "20px auto" }}>
            <FormControl fullWidth sx={{ mb: 3 }} >
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required
                label="Company Name" variant="outlined" onChange={(event) => {
                  setCompany(event.target.value);
                }} />
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required
                label="User Name" variant="outlined"
                onChange={(event) => {
                  setUsername(event.target.value);
                }} />
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required
                type='password' label="Password"
                variant='outlined' onChange={(event) => {
                  setPassword(event.target.value);
                }} />
            </FormControl>
            <div style={{ textAlign: "center" }}>
              <Button variant="contained" style={{
                backgroundColor: "rgb(61 65 68)",
                height: "35px", width: "30%",
                textTransform: "capitalize"
              }}
                onClick={role === "admin" ? handelAdminLogIn : handelDoctorLogIn}
              > Login
              </Button>
              {loginRequest && !loginResponse ? (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Spinner animation="border" variant="success" />
                </div>
              ) : loginResponse && error ? (
                <h5 style={{ color: "red" }}>{error}</h5>
              ) : null}
            </div>

          </div>
        </div>
      </div>
    </Box>
  );
}

export default LoginAsEmployee;
